export default {
  administratorCallConfigNotFound: 'Administrator call configuration not found',
  administratorCallConfigSuccessfullyUpdated: 'Administrator call configuration successfully updated',
  administratorCalls: 'Administrator calls',
  administratorCallsList: 'Administrator calls list',
  administratorCallsNotFound: 'Administrator calls not found',
  adminWhoMadeTheCall: 'Administrator who made the call',
  callAnswered: 'Call answered',
  callBusy: 'Call busy',
  callCompleted: 'Call completed',
  callMissed: 'Call missed',
  callRinging: 'Call ringing',
  calls: 'Calls',
  clientId: 'Client id',
  duration: 'Duration',
  enterClientEmail: 'Enter client email',
  enterClientId: 'Enter client id',
  enterClientPassword: 'Enter client password',
  loadingAdministratorCallConfig: 'Loading administrator call configuration',
  loadingCalls: 'Loading calls',
  noPersonCallsFound: 'No calls were found for this person',
  personName: 'Person name',
  setAdministratorCallConfig: 'Set administrator call configuration',
  updatePassword: 'Update password',
  voiceMailMissed: 'Voice mail missed',
  withoutName: 'Without name',
  withoutStatus: 'Without status'
}
